import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { ResponseApiModel } from '../../../../../../core/models/general.models';
import { UserProfileStatusApiModel } from '../models/user-profile.model';

@Injectable({
    providedIn: 'root',
})
export class UserProfileService {
    private readonly route = `${environment.apiHost}/api/v1/users`;

    constructor(private httpClient: HttpClient) {}

    getUserProfileStatus(): Observable<UserProfileStatusApiModel> {
        return this.httpClient
            .get<ResponseApiModel<UserProfileStatusApiModel>>(`${this.route}/account-verification`)
            .pipe(
                map((response) => {
                    return response.result;
                }),
            );
    }
}
